(() => {
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("[js-product-video-play-button]")
      .forEach((element) => {
        element.click();
      });
    if (window.location.pathname.includes("/products")) {
      if (!window.location.hash) {
        // console.log("No Hash");
        window.scrollTo(0, 0);
      } else {
        setTimeout(() => {
          // console.log("w/ Hash");
          const targetId = window.location.hash.substring(1); // remove the "#"
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth" }); // or "auto"
          }
        }, 1000);
      }
    }

    document.querySelectorAll("product-form>form").forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const priceContainer = document.querySelector("[js-price-container]");
      if (!input || !priceContainer) return;
      input.addEventListener("change", () => {
        console.log(priceContainer.getAttribute(`variant-id-${input.value}`));
      });
    });

    document.querySelectorAll("[js-menu-item-collapse]").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        element.classList.toggle("open");
      });
    });

    document
      .querySelectorAll("button.product__media-toggle")
      .forEach((element) => {
        element.addEventListener("click", () => {
          document
            .querySelectorAll(
              'deferred-media[data-media-id="' +
                element.getAttribute("data-media-id") +
                '"]>button'
            )
            .forEach((button) => {
              button.click();
            });
        });
      });

    document.querySelectorAll("header").forEach((element) => {
      element.addEventListener("click", (e) => {
        const closeButton = element.querySelector("[js-close-menu]");
        if (!closeButton) return;
        console.log(e.target.closest("details[open]"));
        if (
          closeButton.closest("details").hasAttribute("open") &&
          !e.target.closest(".drawer__container")
        )
          element.querySelector("[js-close-menu]").click();
      });
    });

    const searchContainer = document.querySelector(
      "[js-header-search-container]"
    );
    if (searchContainer) {
      document
        .querySelectorAll("[js-header-search-icon]")
        .forEach((element) => {
          element.addEventListener("click", () => {
            searchContainer.classList.add("open");
          });
        });
      document
        .querySelectorAll(
          "[js-header-search-container] [js-header-search-close]"
        )
        .forEach((element) => {
          element.addEventListener("click", () => {
            searchContainer.classList.remove("open");
            searchContainer.querySelector(
              "[data-predictive-search]"
            ).style.maxHeight = "0px";
          });
        });
    }

    TresholdApp.init();
    questionAnswerApp.init();
    customDropdownApp.init();
    TabApp.init();
  });

  var customDropdownApp = (() => {
    var open = (container) => {
      if (!container) return;
      container.classList.add("open");
    };
    var close = (container) => {
      if (!container) return;
      container.classList.remove("open");
    };
    var initialize = () => {
      document
        .querySelectorAll("[js-custom-dropdown] [js-dropdown-trigger]")
        .forEach((element) => {
          element.addEventListener("click", () => {
            const container = element.closest("[js-custom-dropdown]");
            if (container.classList.contains("open")) close(container);
            else open(container);
          });
        });
      document
        .querySelectorAll("[js-custom-dropdown] [js-dropdown-wrapper]")
        .forEach((element) => {
          element.addEventListener("focusout", () => {
            close(element.closest("[js-custom-dropdown]"));
          });
        });
    };
    return {
      init: initialize,
    };
  })();

  var questionAnswerApp = (() => {
    var open = (element) => {
      if (!element) return;
      close(element);
      element.classList.add("open");
      const answer = element.querySelector("[js-answer]");
      answer.style.maxHeight = answer.scrollHeight + "px";
    };
    var close = (element) => {
      if (!element) return;
      const container = element.closest("[js-question-answer-container]");
      if (!container) return;
      container
        .querySelectorAll("[js-question-answer]")
        .forEach((subElement) => {
          subElement.classList.remove("open");
          const answer = subElement.querySelector("[js-answer]");
          answer.style.maxHeight = "0px";
        });
    };
    var initialize = () => {
      document
        .querySelectorAll("[js-question-answer-container] [js-trigger]")
        .forEach((element) => {
          element.addEventListener("click", () => {
            const bigElement = element.closest("[js-question-answer]");
            if (!bigElement) return;
            if (bigElement.classList.contains("open")) {
              close(bigElement);
            } else {
              open(bigElement);
            }
          });
        });
    };
    return {
      init: initialize,
    };
  })();

  var closeHeaderDrawerMenu = () => {};

  var setProductInfoSticky = (deltaScroll) => {
    const productInfoContainer = document.querySelector(
      "html.product-template product-info"
    );
    if (!productInfoContainer) return;
    const minValue = window.innerHeight - productInfoContainer.clientHeight;
    if (minValue > 0) productInfoContainer.style.top = "0px";
    else {
      let scrollTop =
        parseInt(productInfoContainer.getAttribute("data-top")) - deltaScroll;
      scrollTop = scrollTop > 0 ? 0 : scrollTop;
      scrollTop = scrollTop < minValue ? minValue : scrollTop;
      productInfoContainer.setAttribute("data-top", scrollTop);
      productInfoContainer.style.top = scrollTop + "px";
    }
  };

  let lastScrollTop = 0;

  window.addEventListener("scroll", function () {
    // Get the current scroll position
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (window.innerWidth < 1000 && scrollTop > 80) {
      if (scrollTop > lastScrollTop) {
        document.querySelector("header").style.top = "-80px";
      } else {
        document.querySelector("header").style.top = "0";
      }
    }

    setProductInfoSticky(scrollTop - lastScrollTop);

    lastScrollTop = scrollTop;
  });

  window.addEventListener("scroll", function () {
    // Get the current scroll position
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 80) {
      document.querySelector("header").classList.add("secondary");
    } else {
      document.querySelector("header").classList.remove("secondary");
    }
  });

  var TresholdApp = (() => {
    let tresholdContainer;
    let tresholdValue1;
    let tresholdValue2;
    let is_already_added_gift_product_1;
    let is_already_added_gift_product_2;
    let giftProducts;
    let autoGiftProduct;
    let addButtons = [];

    var hide = () => {
      if (!tresholdContainer) return;
      tresholdContainer.classList.remove("active");
    };

    var show = () => {
      if (!tresholdContainer) return;
      tresholdContainer.classList.add("active");
    };

    var add = (variantId) => {
      const formData = {
        id: variantId,
        quantity: 1,
        properties: { _gift: new Date().getTime() },
      };

      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      formData.sections = cart
        .getSectionsToRender()
        .map((section) => section.id);
      formData.sections_url = window.location.pathname;

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to add gift to cart");
          }
          return response.json();
        })
        .then((data) => {
          cart.renderContents(data);
        })
        .catch((error) => {
          console.error("Error adding gift to cart:", error);
        });
    };

    var remove = (id) => {
      const formData = {
        id: id,
        quantity: 0,
      };

      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      formData.sections = cart
        .getSectionsToRender()
        .map((section) => section.id);
      formData.sections_url = window.location.pathname;

      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to add gift to cart");
          }
          return response.json();
        })
        .then((data) => {
          cart.renderContents(data);
        })
        .catch((error) => {
          console.error("Error adding gift to cart:", error);
        });
    };

    var check1 = (cart) => {
      if (!cart) return;
      const items = cart.items;
      if (
        tresholdValue1 &&
        cart.total_price > tresholdValue1 &&
        tresholdValue1 > 0
      ) {
        let addedCount = 0;
        tresholdContainer
          .querySelectorAll("[js-gift-product]")
          .forEach((giftProduct) => {
            for (let i = 0; i < items.length; i++) {
              if (
                giftProduct.getAttribute("data-variant-id") ==
                  String(items[i].variant_id) &&
                items[i].properties.hasOwnProperty("_gift")
              ) {
                addedCount++;
                giftProduct.classList.add("added");
                break;
              } else {
                giftProduct.classList.remove("added");
              }
            }
          });
        if (addedCount >= 3) is_already_added_gift_product_1 = true;
        if (is_already_added_gift_product_1 == false) show();
      } else {
        hide();
        for (let i = 0; i < items.length; i++) {
          if (
            giftProducts.includes(String(items[i].variant_id)) &&
            items[i].properties.hasOwnProperty("_gift")
          ) {
            remove(items[i].key);
            tresholdContainer
              .querySelector(
                `[js-gift-product][data-variant-id="${items[i].variant_id}"]`
              )
              .classList.remove("added");
          }
        }
      }
      if (is_already_added_gift_product_1) hide();
    };

    var check2 = (cart) => {
      console.log("checking second treshold value status ...", autoGiftProduct);
      if (!cart) return;
      const items = cart.items;
      if (
        tresholdValue2 &&
        cart.total_price >= tresholdValue2 &&
        tresholdValue2 > 0
      ) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].variant_id == autoGiftProduct) {
            is_already_added_gift_product_2 = true;
            break;
          }
        }
        if (!is_already_added_gift_product_2) add(autoGiftProduct);
      } else if (
        tresholdValue2 &&
        cart.total_price < tresholdValue2 &&
        tresholdValue2 > 0
      ) {
      }
    };

    var checkTresholdAndAddGiftProduct = () => {
      initialize();
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch cart items");
          }
          return response.json();
        })
        .then((cart) => {
          check1(cart);
          check2(cart);
        })
        .catch((error) => {
          console.error("Error fetching cart items:", error);
        });
    };

    var initialize = () => {
      tresholdContainer = document.querySelector("[js-treshold-gift-products]");
      if (!tresholdContainer) return;

      hide();

      tresholdValue1 = parseInt(
        tresholdContainer.getAttribute("data-treshold-value-1")
      );
      tresholdValue2 = parseInt(
        tresholdContainer.getAttribute("data-treshold-value-2")
      );

      is_already_added_gift_product_1 = false;
      is_already_added_gift_product_2 = false;

      giftProducts = [];
      tresholdContainer
        .querySelectorAll("[js-gift-product]")
        .forEach((giftProduct) => {
          giftProducts.push(giftProduct.getAttribute("data-variant-id"));
        });

      autoGiftProduct = tresholdContainer.getAttribute(
        "data-auto-gift-product"
      );

      tresholdContainer
        .querySelectorAll("[js-add-gift-to-cart]")
        .forEach((element) => {
          if (addButtons.includes(element)) return;
          addButtons.push(element);
          element.addEventListener("click", () => {
            fetch("/cart.js", {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Failed to fetch cart items");
                }
                return response.json();
              })
              .then((cart) => {
                const items = cart.items;
                let addedCount = 0;
                tresholdContainer
                  .querySelectorAll("[js-gift-product]")
                  .forEach((giftProduct) => {
                    for (let i = 0; i < items.length; i++) {
                      if (
                        giftProduct.getAttribute("data-variant-id") ==
                          String(items[i].variant_id) &&
                        items[i].properties.hasOwnProperty("_gift")
                      ) {
                        addedCount++;
                        giftProduct.classList.add("added");
                        break;
                      } else {
                        giftProduct.classList.remove("added");
                      }
                    }
                  });
                if (addedCount < 3) {
                  element.style.opacity = "0.2";
                  add(
                    element
                      .closest("[js-gift-product]")
                      .getAttribute("data-variant-id")
                  );
                }
              })
              .catch((error) => {
                console.error("Error fetching cart items:", error);
              });
          });
        });
    };
    return {
      init: initialize,
      check: checkTresholdAndAddGiftProduct,
    };
  })();

  var TabApp = (() => {
    var open = (container, index) => {
      if (!container) return;
      container.querySelectorAll("[js-tab-body]").forEach((element) => {
        element.classList.remove("active");
        if (element.getAttribute("data-id") == index) {
          element.classList.add("active");
        }
      });
    };
    var initialize = () => {
      document.querySelectorAll("[js-tab-heading]").forEach((element) => {
        element.addEventListener("click", () => {
          const container = element.closest("[js-container]");
          container
            .querySelector("[js-tab-heading].active")
            .classList.remove("active");
          element.classList.add("active");
          open(container, element.getAttribute("data-id"));
        });
      });
    };
    return {
      init: initialize,
    };
  })();

  document.addEventListener("Cart:Updated", () => {
    TresholdApp.check();
  });

  document.addEventListener("Cart:Open", () => {
    TresholdApp.check();
  });
})();
